export const SHOW_LOGIN_MODAL = '@@app/SHOW_LOGIN_MODAL';
export const HIDE_LOGIN_MODAL = '@@app/HIDE_LOGIN_MODAL';
export const SET_CURRENT_SURVEY = '@@app/SET_CURRENT_SURVEY';
export const SET_ANONYMOUS_USER = '@@app/SET_ANONYMOUS_USER';
export const SET_LOADING = '@@app/SET_LOADING';
